<template>
  <div>
      <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                  :page-total="pageTotal" :table-data="tableData" :show-create-btn="true" create-btn-title="创建通讯录"
                  @fetchData="fetchData" @btnHandler="btnHandler">
        <template slot="searchForm">
          <FormItem class="margin-bottom-0">
            <Input v-model="params.keyword" placeholder="标题" style="width: 320px;"></Input>
          </FormItem>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Tooltip content="详情" placement="top" transfer>
            <Button type="primary" size="small" icon="md-eye" style="margin-right: 5px"
                    @click="btnHandler('details', row)"/>
          </Tooltip>
          <Tooltip content="编辑" placement="top" transfer>
            <Button type="info" size="small" icon="md-create" style="margin-right: 5px" @click="btnHandler('edit', row)"/>
          </Tooltip>
          <Poptip confirm title="确定要解散吗?" placement="left" @on-ok="btnHandler('delete', row)"
                  @on-cancel="btnHandler('cancel', row)" transfer>
            <Button type="warning" size="small" icon="md-trash"></Button>
          </Poptip>
        </template>
      </page-table>

    <Drawer v-model="forumObj.show" :mask-closable="false" width="1000" :styles="styles" @on-close="closeForm">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{formItem.id ? '编辑' : '新建'}}通讯录</span>
      </p>
      <Form ref="myForm" :rules="ruleValidate" :model="formItem" :label-width="110">
        <FormItem label="通讯录标题" prop="title">
          <Input type="text" v-model="formItem.title" placeholder="请输入标题"></Input>
        </FormItem>
        <FormItem label="子标题" prop="son_title">
          <Input type="text" v-model="formItem.son_title" placeholder="请输入子标题"></Input>
        </FormItem>
        <FormItem label="选择群主" >
          <i-select v-model="formItem.member_id" :loading="searchLoading" :remote-method="getMemberListHandle" filterable remote>
              <i-option v-for="item in memberList" :key="item.id" :value="item.id" :label="item.username || item.nickname"></i-option>
          </i-select>
        </FormItem>
        <FormItem label="通讯录图" prop="picture">
          <div class="demo-upload-list">
            <img :src="formItem.picture">
            <div class="demo-upload-list-cover">
              <Icon type="ios-eye-outline" @click.native="handleView(formItem.picture)"></Icon>
            </div>
          </div>
          <Upload ref="upload" :on-success="uploadSuccessPictureImg" :headers="headers" accept="image/jpg,image/png,image/jpeg" :format="['jpg','jpeg','png']" :max-size="uploadConfig.maxFileSize" :on-exceeded-size="handleMaxSize" type="drag" :show-upload-list="false" :action="uploadConfig.imageAction" style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
          <Tooltip placement="top" style="margin-left: 10px;">
            <Icon type="ios-alert" size="20" color="#ff9900" />
            <div slot="content">
              <p>图片大小建议控制在400kb以下</p>
              <p>分辨率宽高比建议：3(宽):2(高)</p>
            </div>
          </Tooltip>
        </FormItem>
        <FormItem label="详情页图">
          <div class="demo-upload-list">
            <img :src="formItem.detail_picture">
            <div class="demo-upload-list-cover">
              <Icon type="ios-eye-outline" @click.native="handleView(formItem.detail_picture)"></Icon>
            </div>
          </div>
          <Upload ref="upload" :on-success="uploadSuccessPictureDetailImg" :headers="headers" accept="image/jpg,image/png,image/jpeg" :format="['jpg','jpeg','png']" :max-size="uploadConfig.maxFileSize" :on-exceeded-size="handleMaxSize" type="drag" :show-upload-list="false" :action="uploadConfig.imageAction" style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
          <Tooltip placement="top" style="margin-left: 10px;">
            <Icon type="ios-alert" size="20" color="#ff9900" />
            <div slot="content">
              <p>图片大小建议控制在400kb以下</p>
              <p>分辨率宽高比建议：3(宽):2(高)</p>
            </div>
          </Tooltip>
        </FormItem>
        <FormItem label="查看人次" >
          <InputNumber type="text" v-model="formItem.see_number" ></InputNumber>
        </FormItem>
        <FormItem label="加入金额" >
          <InputNumber type="text" v-model="formItem.join_price" ></InputNumber>
        </FormItem>
        <FormItem label="仅VIP可见" >
          <i-switch  v-model="formItem.is_hide" />
        </FormItem>
        <FormItem label="内容" prop="content">
          <tinymce ref="basic_info" :height="300" v-model="formItem.content" @input="formItem.content = $event"></tinymce>
        </FormItem>
      </Form>
      <div class="drawer-footer">
        <Button type="text" @click="closeForm" class="margin-right-10">取消</Button>
        <Button type="primary" @click="submit" :loading="forumObj.loading">确定</Button>
      </div>
    </Drawer>

    <Drawer v-model="detailDrawer.show" :title="detailDrawer.title" :mask-closable="false" width="1000" :styles="styles" @on-close="closeForm">
       <detail :row-data="detailDrawer.rowData"></detail>
    </Drawer>
    <Modal title="大图预览" v-model="imageVisible">
      <img :src="imageName" v-if="imageVisible" style="width: 100%">
    </Modal>
  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import { delBook, getList, saveAddressBook } from '../../api/address-book'
import tinymce from '../../components/tinymce/index'
import { getToken } from '../../libs/util'
import { mapState } from 'vuex'
import { getMemberList } from '../../api/member'
import Detail from '../address-book/components/detail'
export default {
  name: 'address-book-list',
  components: { Detail, pageTable, tinymce },
  data () {
    return {
      params: {
        keyword: ''
      },
      tableLoading: false,
      tableData: [],
      pageTotal: 0,
      styles: {
        height: 'calc(100vh - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      forumObj: {
        show: false,
        loading: false,
        index: 0
      },
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      formItem: {
        title: '',
        son_title: '',
        picture: '',
        detail_picture: '',
        see_number: 0,
        join_price: 0,
        is_hide: false,
        content: '',
        member_id: ''
      },
      ruleValidate: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        son_title: [
          { required: true, message: '子标题不能为空', trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '图片不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ]
      },
      imageVisible: false,
      imageName: '',
      memberList: [],
      detailDrawer: {
        show: false,
        loading: false,
        rowData: {},
        title: '通讯录详情'
      },
      searchLoading: false
    }
  },
  computed: {
    tableColumns () {
      return [
        { title: 'id', key: 'id', width: 60 },
        { title: '发起人(群主)', key: 'nickname', width: 120 },
        { title: '标题', key: 'title' },
        { title: '图片', key: 'picture' },
        { title: '查看人次', key: 'see_number' },
        { title: '群总人数', key: 'people_number' },
        { title: '创建时间', key: 'create_time' },
        { title: '操作', slot: 'action', width: 100, align: 'center', fixed: 'right' }
      ]
    },
    ...mapState({
      uploadConfig: state => {
        return state.app.uploadConfig
      }
    })
  },
  created () {
    this.getMemberListHandle()
  },
  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      getList(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },
    new () {
      this.formItem = {
        title: '',
        son_title: '',
        picture: '',
        detail_picture: '',
        see_number: 0,
        join_price: 0,
        is_hide: false,
        content: '',
        member_id: ''
      }
      this.$refs['myForm'].resetFields()
      this.forumObj.show = true
    },
    edit (row) {
      this.formItem = { ...row }
      this.forumObj.show = true
    },
    details (row) {
      this.detailDrawer.show = true
      this.detailDrawer.rowData = { ...row }
    },
    delete (row) {
      delBook({ id: row.id }).then(() => {
        this.$Message.success({
          content: '解散成功'
        })
      }).finally(() => {
        this.fetchData()
      })
    },
    handleView (name) {
      this.imageName = name
      this.imageVisible = true
    },
    uploadSuccessPictureImg (response, file) {
      this.formItem.picture = response.data.fileUrl
    },
    uploadSuccessPictureDetailImg (response, file) {
      this.formItem.detail_picture = response.data.fileUrl
    },
    handleMaxSize (file) {
      const fileSize = (file.size / 1024 > 1000) ? (file.size / 1024 / 1024).toFixed(2) + 'M' : (file.size / 1024).toFixed(2) + 'KB'
      this.$Notice.warning({
        title: '超过文件大小限制',
        desc: '当前文件  ' + fileSize + ' 最大支持' + this.uploadConfig.maxFileSize + 'KB'
      })
    },
    getMemberListHandle (query) {
      getMemberList({ username: query, page_size: 100000 }).then(({ data }) => {
        this.memberList = data.data
      })
    },
    submit () {
      this.$refs['myForm'].validate((valid) => {
        if (valid) {
          this.formItem.type = 0
          this.forumObj.loading = true
          saveAddressBook(this.formItem).then(res => {
            this.$Message.success(res.msg)
            this.forumObj.show = false
            this.forumObj.loading = false
            this.fetchData()
          }).finally(() => {
            this.forumObj.loading = false
          })
        }
      })
    },
    closeForm () {
      this.$refs['myForm'].resetFields()
      this.forumObj.show = false
    }
  }
}
</script>

<style scoped>
  /deep/ .ql-editor {
    height: 150px;
  }

  .demo-upload-list{
    display: inline-block;
    width: 90px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
